import { Api } from "../api/Api";
export const supportingdoc = () => {
  const getSupportingDoc = async (uuid) => {
    const response = await Api.get("api/v1/get-supporting-doc?uuid="+uuid, {});
    return response;
  };
  return { getSupportingDoc };
};
